<div class="p-4">
    <h1 mat-dialog-title>Tiered Nights</h1>
    <div mat-dialog-content>
        <div class="row">
            <div class="col-12">
                <table class="nightly-range-table" mat-table [dataSource]="dataSource">
                    <ng-container [matColumnDef]="column.column" *ngFor="let column of displayedColumns">
                        <th mat-header-cell *matHeaderCellDef>{{ column.display }}</th>
                        <td mat-cell *matCellDef="let element">{{ element[column.column] }}</td>    
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnNames"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnNames;"></tr>
                </table>          
            </div>
        </div>
        <div class="row p-3">
            <div class="col">
                <div class="extra-night">Extra Night Price: {{extraNightPrice}} </div>
            </div>
        </div>
    </div>
    <div class="my-2 d-flex justify-content-end">
        <button mat-raised-button (click)="onCloseClick()">
            <mat-icon class="action-button-icon">close</mat-icon>
            Close
        </button>
    </div>
</div>
